/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  PayByAmountDigitalBillDto,
  SplitByAmountSuccessResponse,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    PayByAmountDigitalBillDtoFromJSON,
    PayByAmountDigitalBillDtoToJSON,
    SplitByAmountSuccessResponseFromJSON,
    SplitByAmountSuccessResponseToJSON,
} from '../models';

export interface InitiateSplitPaymentRequest {
    locationId: string;
    reference: string;
    payByAmountDigitalBillDto: PayByAmountDigitalBillDto;
}

/**
 * 
 */
export class SplitPaymentControllerApi extends runtime.BaseAPI {

    /**
     */
    async initiateSplitPaymentRaw(requestParameters: InitiateSplitPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SplitByAmountSuccessResponse>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling initiateSplitPayment.');
        }

        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling initiateSplitPayment.');
        }

        if (requestParameters.payByAmountDigitalBillDto === null || requestParameters.payByAmountDigitalBillDto === undefined) {
            throw new runtime.RequiredError('payByAmountDigitalBillDto','Required parameter requestParameters.payByAmountDigitalBillDto was null or undefined when calling initiateSplitPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/locations/{locationId}/digital-bills/{reference}/pay-by-amount`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayByAmountDigitalBillDtoToJSON(requestParameters.payByAmountDigitalBillDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SplitByAmountSuccessResponseFromJSON(jsonValue));
    }

    /**
     */
    async initiateSplitPayment(requestParameters: InitiateSplitPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SplitByAmountSuccessResponse> {
        const response = await this.initiateSplitPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
